import { render, staticRenderFns } from "./UsersViewForecasts.vue?vue&type=template&id=d37630be&"
import script from "./UsersViewForecasts.vue?vue&type=script&lang=js&"
export * from "./UsersViewForecasts.vue?vue&type=script&lang=js&"
import style0 from "./UsersViewForecasts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports